/** Whether `pathname` is the page at `path` or a page below it (`/roles/edit/abc` is below `/roles`). */
export const isOnPath = (pathname: string, path: string): boolean =>
  pathname === path || pathname.startsWith(`${path}/`);
